import Phaser from "phaser";
import { textStyle } from "./textStyles";

/**
 * HP-бокс пары: общая рамка, заголовок "Имя1 & Имя2", уровень, тонкий бар.
 * Цвет бара меняется по цветовому коду через setFillStyle на дочернем
 * Rectangle. Анимация изменения тоунится за ~400 мс.
 */
export default class HPBox {
  private container: Phaser.GameObjects.Container;
  private barFill: Phaser.GameObjects.Rectangle;
  private hpText: Phaser.GameObjects.Text;
  private maxBarWidth: number;

  constructor(
    private scene: Phaser.Scene,
    x: number,
    y: number,
    nameA: string,
    nameB: string,
    level: number,
    private maxHp: number,
    side: "player" | "enemy",
  ) {
    this.container = scene.add.container(x, y);
    this.container.setDepth(100);

    const frameKey = side === "player" ? "ui_hpbox_player" : "ui_hpbox_enemy";
    const frame = scene.add.image(0, 0, frameKey).setOrigin(0, 0);
    this.container.add(frame);

    const title = scene.add.text(4, 2, `${nameA} & ${nameB}`, textStyle(8));
    this.container.add(title);

    const lvl = scene.add.text(4, 14, `Lv ${level}`, textStyle(8));
    this.container.add(lvl);

    const barX = 50;
    const barY = 16;
    this.maxBarWidth = 100;

    const barBg = scene.add.rectangle(barX, barY, this.maxBarWidth, 6, 0x333333).setOrigin(0, 0);
    this.container.add(barBg);

    this.barFill = scene.add.rectangle(barX, barY, this.maxBarWidth, 6, 0x55cc55).setOrigin(0, 0);
    this.container.add(this.barFill);

    this.hpText = scene.add.text(4, 26, `HP ${maxHp}/${maxHp}`, textStyle(8));
    this.container.add(this.hpText);
  }

  /** Плавно затоунить ширину бара и обновить текст HP. */
  updateHp(newHp: number): Promise<void> {
    return new Promise((resolve) => {
      const ratio = Phaser.Math.Clamp(newHp / this.maxHp, 0, 1);
      const targetWidth = this.maxBarWidth * ratio;

      this.scene.tweens.add({
        targets: this.barFill,
        width: targetWidth,
        duration: 400,
        ease: "Quad.easeOut",
        onUpdate: () => {
          const r = this.barFill.width / this.maxBarWidth;
          let color = 0x55cc55;
          if (r < 0.2) color = 0xcc3333;
          else if (r < 0.5) color = 0xddcc44;
          this.barFill.setFillStyle(color);
        },
        onComplete: () => resolve(),
      });

      this.hpText.setText(`HP ${Math.max(0, Math.round(newHp))}/${this.maxHp}`);
    });
  }

  destroy(): void {
    this.container.destroy(true);
  }
}
